import type { JSX } from 'react';

import { Button } from '@/components/ui/button';

interface ActivityErrorStateProps {
  onRetry: () => void;
}

const ActivityErrorState = ({ onRetry }: ActivityErrorStateProps): JSX.Element => (
  <div className="rounded-lg border border-error/40 bg-error-light px-4 py-3 text-sm text-error font-body">
    <p className="m-0 mb-2 font-medium">No se pudo cargar la actividad.</p>
    <Button variant="outline" size="sm" onClick={onRetry}>
      Reintentar
    </Button>
  </div>
);

export default ActivityErrorState;
